// extracted by mini-css-extract-plugin
export default {"Emojify":"bbf_a bhe_g"};